/**
 * Big-endian packed BCD, as used for wPlayerMoney (3 bytes) and wPlayerCoins (2 bytes).
 * Nibbles above 9 (possible after glitches) are read at face value so the
 * result is still deterministic; `write` only ever emits valid BCD.
 */
export const bcd = {
  read(b: Uint8Array): number {
    let n = 0;
    for (const byte of b) n = n * 100 + (byte >>> 4) * 10 + (byte & 0x0f);
    return n;
  },
  write(n: number, len: number): Uint8Array {
    if (!Number.isInteger(len) || len <= 0) throw new RangeError(`bcd length ${len}`);
    const max = 10 ** (len * 2) - 1;
    if (!Number.isInteger(n) || n < 0 || n > max) throw new RangeError(`bcd value ${n} does not fit in ${len} bytes`);
    const out = new Uint8Array(len);
    let v = n;
    for (let i = len - 1; i >= 0; i--) {
      const lo = v % 10;
      v = Math.floor(v / 10);
      const hi = v % 10;
      v = Math.floor(v / 10);
      out[i] = (hi << 4) | lo;
    }
    return out;
  },
  isValid(b: Uint8Array): boolean {
    for (const byte of b) if ((byte >>> 4) > 9 || (byte & 0x0f) > 9) return false;
    return true;
  },
};
